import React from "react";

export default function SpBoottom() {
  const data1 = [
    {
      img: "Feature1.svg",
      heading: "Automated Document Generation:",
      text: "System generated documents like Demand Drafts, Certificates, and Sale Deed drafts reduce paperwork and legal costs.",
    },
    {
      img: "Feature2.svg",
      heading: "Financial & Payment Tracking:",
      text: "The platform provides an intuitive process for payment tracking and automatic reminders to manage financials more effectively.",
    },
  ];

  const data2 = [
    {
      img: "Feature3.svg",
      heading: "Project & Material Management:",
      text: "Builders can effectively track project goals, tasks, resources, and materials for a smooth project execution and operational efficiency.",
    },
    {
      img: "Feature4.svg",
      heading: "Performance Tracking & Compliance:",
      text: "The system tracks performance of sales representatives to make sure teams are meeting their goals. It also adheres to RERA compliance.",
    },
  ];

  return (
    <div className="row super-buildup-feature-wrapper my-5">
      <div className="col-12 text-center">
        <h2 className="super-buildup-feature-h2">More features</h2>
      </div>
      <div className="col-12 px-6">
        <div className="row mx-0 me-md-5 justify-content-center">
          {data1?.map((val, idx) => (
            <div key={idx} className="col-md-5 col-12 p-md-4 p-2">
              <div className="super-buildup-feature-card row align-items-baseline">
                <div className="col-2">
                  <img
                    src={`/images/${val.img}`}
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="col-10">
                  <h3>{val?.heading}</h3>
                  <p>{val?.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="row mx-0 ms-md-5 justify-content-center">
          {data2?.map((val, idx) => (
            <div key={idx} className="col-md-5 col-12 px-md-4 px-2">
              <div className="super-buildup-feature-card row align-items-baseline">
                <div className="col-2">
                  <img
                    src={`/images/${val.img}`}
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="col-10">
                  <h3>{val?.heading}</h3>
                  <p>{val?.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
